import { Plus } from "lucide-react";

const ITEMS = [
  "Transparent Coordination",
  "Dedicated Patient Support",
  "Travel & Accommodation Assistance",
  "Family Assistance During Treatment",
  "International Patient Care",
];

export default function MarqueeBand() {
  return (
    <div
      className="overflow-hidden border-y border-border bg-white py-7"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {ITEMS.map((t) => (
              <span key={`${dup}-${t}`} className="flex items-center">
                <span className="whitespace-nowrap px-10 font-serif text-2xl italic tracking-tight text-ink/70 md:text-3xl">
                  {t}
                </span>
                <Plus className="h-4 w-4 shrink-0 text-sage" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
